module.exports = __webpack_public_path__ + "assets/events_war_black.dc179c55.svg";